import { DocumentGroup } from 'types/documentGroup';
import { createAction } from 'typesafe-actions';
import { GroupsActionTypes } from './types';

// eslint-disable-next-line import/prefer-default-export
export const updateGroupsStorage = createAction(GroupsActionTypes.UPDATE_GROUPOUTPUTS)<
  DocumentGroup[]
>();
